module.exports = __webpack_public_path__ + "static/img/need-bg-02.2c216bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/need-bg-02.png
// module id = 9FXO
// module chunks = 1